import { makeStyles } from '@material-ui/core/styles';
import React, { useState, useEffect, Fragment } from 'react';

// URL
import useMember from './useMember';
import {
    member as v_member,
    basic,
    Values,
    member,
    SNACKBAR_TIME,
} from '../request/values';

// Snackbar
import CustomSnackBar, { iSnackBar } from './SnackBar';
import ToastStr from '../request/toastStr';
import { Color } from '@material-ui/lab/Alert';

import { useSnackbar } from 'notistack';

// Card
import {
    Box,
    Button,
    Card,
    CardActions,
    CardHeader,
    CardMedia,
    createStyles,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    Grid,
    IconButton,
    LinearProgress,
    List,
    ListItem,
    Theme,
    Typography,
    withStyles,
} from '@material-ui/core';
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';
import { getMember } from '../request/request';
import NumberFormat from 'react-number-format';
import LinearDeterminate, { LinearProgressBar } from './LinearProgress';
import axios from 'axios';
import { COLORS } from './Theme';
import TitleBar from './header/TitleBar';
import { useHistory } from 'react-router-dom';
import DialogConfirm from './Dialog';
import clsx from 'clsx';
import { height } from '@material-ui/system';

const SERVER = basic.server;

const useStyles = makeStyles((theme: Theme) => ({
    titleIcon: {
        width: '6vw',
    },
    licenseList: {
        paddingTop: '12px',
        //alignContent: 'center',
        width: '100vw',
        height: '88vh',
        overflowY: 'auto',
        fontFamily: 'NanumB',
        fontWeight: 'bold',
        fontSize: '4vw',
        color: `${COLORS.BROWNISH_GREY}`,
        // minWidth: 405,
        [theme.breakpoints.up('md')]: {
            padding: '50px 5vw',
            height: '100vh',
        },
        [theme.breakpoints.up('lg')]: {
            padding: '50px 10vw',
            height: '100vh',
        },
    },
    card: {
        width: '100%',
        height: 'auto',
        border: 'solid 1px #d3d3d3',
        boxShadow: 'none',
        backgroundSize: 'contain',
        paddingTop: '1.2vh',
        paddingBottom: '1.2vh',
    },
    cardHeader: {
        '& span > p': {
            fontSize: '3vw',
            color: `${COLORS.BROWNISH_GREY}`,
            fontFamily: 'NanumR',
            fontWeight: 'bold',
            [theme.breakpoints.up('md')]: {
                fontSize: '2vw',
            },
        },
        '& #cardHelpIcon span img': {
            width: '10vw',
            height: '10vw',
        },
        '& #cardHelpIcon': {
            padding: 0,
        },
        paddingTop: 0,
        paddingLeft: '2.5vw',
        paddingBottom: 0,
        alignItems: 'flex-start',
    },
    media: {
        height: '25.5vh',
        width: '94%',
        margin: 'auto',
        backgroundSize: 'contain',
        [theme.breakpoints.up('md')]: {
            margin: '3vh auto',
        },
    },
    cardAction: {
        height: '2vh',
        padding: '4vw',
        margin: 5,
    },

    // expand: {
    //     transform: 'rotate(0deg)',
    //     marginLeft: 'auto',
    //     transition: theme.transitions.create('transform', {
    //         duration: theme.transitions.duration.shortest,
    //     }),
    // },
    // expandOpen: {
    //     transform: 'rotate(180deg)',
    // },

    // avatar: {
    //   backgroundColor: red[500],
    // },
    overlay: {
        backgroundColor: `${COLORS.PUMPKIN}`,
        zIndex: 100,
        position: 'absolute',
        opacity: 0.9,
        // width: '100%',
        // height: 350,
        // height: '100%',
        // height: '49vh',
        // height 'inherit',
        width: '100%',
        height: '100%',
        top: 0,
        justifyContent: 'center',
        alignItems: 'center',
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
        '& img': {},
    },
    nextOverlay: {
        backgroundColor: `${COLORS.WATER_BLUE}`,
    },
    overlayImage: {
        width: '20vw',
        height: 'auto',
        marginBottom: '2vh',
        backgroundSize: 'contain',
        [theme.breakpoints.up('md')]: {
            width: '12vw',
        },
    },

    icon: {
        width: '4.5vw',
        height: '4.5vw',
        maxWidth: '35px',
        maxHeight: '35px',
    },

    button: {
        width: '40vw',
        height: '5vh',
        backgroundColor: `${COLORS.PUMPKIN}`,
        color: `${COLORS.WHITE}`,
        padding: 0,
        ...theme.typography.body1,
        fontFamily: 'NanumB',
        fontWeight: 'bold',
        [theme.breakpoints.up('md')]: {
            width: '60%',
            height: '70%',
            ...theme.typography.body1,
            fontFamily: 'NanumB',
            fontWeight: 'bold',
        },
    },
    title: {
        fontSize: '3.5vw',
    },
    iconHeight: {
        [theme.breakpoints.up('md')]: {
            height: '40px',
        },
    },
    iconItem: {
        [theme.breakpoints.up('md')]: {
            height: '100%',
            display: 'flex',
            alignItem: 'center',
        },
    },
}));

const LicenseList: React.FC<any> = (props) => {
    const [license, setLicense] = useState<iLicenseItem[]>();
    const [now, setNow] = useState<any>();
    const [overlayAttr, setOverlayAttr] = useState<any>();

    const { member } = props;

    const classes = useStyles();
    const history = useHistory();

    const getLicenseList = () => {
        let url = new URL(
            basic.server + v_member.member + v_member.license_list
        );
        let params = {
            companyNum: member.companyNum,
            classVersion: member.classVersion,
        };
        url.search = new URLSearchParams(params).toString();

        console.log(url);
        // fetch(url.toString(), {mode:'cors'}).then((res) => {
        //     return res.json()
        // })
        axios({
            method: 'GET',
            withCredentials: true,
            url: url.toString(),
        })
            .then((res) => res.data)
            .then((data: any) => {
                console.log(data);
                setNow((prevState: any) => data.now);
                setLicense(data.licenses);

                // const arrKeys = data.licenses.map((el:any) => el.licenseStatus);
                // setLastComplete(arrKeys.lastIndexOf('complete'))
                const firstCantIndex = data.licenses.findIndex(
                    (el: any) => el.licenseStatus === 'cant'
                );
                if (firstCantIndex === -1) {
                    setOverlayAttr({ lastLicenseNum: -1, canLicenseName: '' });
                } else {
                    setOverlayAttr({
                        lastLicenseNum:
                            data.licenses[firstCantIndex].licenseNum,
                        canLicenseName:
                            data.licenses[firstCantIndex - 1].licenseName,
                    });
                }
            });
    };
    useEffect(() => {
        getLicenseList();
    }, []);

    useEffect(() => {
        console.log('now changed??', now, new Date());
    }, [now]);

    const setLicenseStatus = (
        e: any,
        index: number,
        status: string,
        regDate: string,
        now: string
    ) => {
        e.preventDefault();
        setNow((prevState: any) => now);
        let l = license;

        if (l != undefined) {
            let g = l[index];
            g.licenseStatus = status;
            // for test
            // g.licenseRegDate = new Date().toString();\
            g.licenseRegDate = regDate;

            console.log('in List setStatus ', g);
            setLicense([...l.slice(0, index), g, ...l.slice(index + 1)]);
        }
    };
    // const LicenseItemRender = license!=null && license.map((item: any, index) => {
    //     return <LicenseItem key={item.licenseNum} {...item} licenseStatus={item.licenseStatus} setLicenseStatus={setLicenseStatus}></LicenseItem>
    // })

    const goLicenseManual = (licenseNum: number) => {
        history.push(`/license/manual/${licenseNum}`);
    };
    /*<TitleBar history={history} title="연구개발" titleIcon="license" titleIconClass={classes.titleIcon}/>*/
    return (
        <div className="contentList">
            <Box display="flex" justifyContent="center" alignItems="center">
                <List className={classes.licenseList}>
                    {license != null &&
                        license.map((item: any, index) => {
                            return (
                                <ListItem
                                    style={{
                                        padding: 0,
                                        paddingBottom: 0,
                                        marginBottom: '1.7vh',
                                    }}
                                >
                                    <LicenseItem
                                        key={item.licenseNum}
                                        now={now}
                                        overlayAttr={overlayAttr}
                                        {...item}
                                        handleHelpClick={(e: any) =>
                                            goLicenseManual(item.licenseNum)
                                        }
                                        licenseStatus={item.licenseStatus}
                                        getLicenseList={getLicenseList}
                                        setLicenseStatus={(
                                            e: any,
                                            status: string,
                                            regDate: string,
                                            now: string
                                        ) =>
                                            setLicenseStatus(
                                                e,
                                                index,
                                                status,
                                                regDate,
                                                now
                                            )
                                        }
                                    ></LicenseItem>
                                </ListItem>
                            );
                        })}
                    {/* {LicenseItemRender} */}
                </List>
            </Box>
        </div>
    );
};

interface iLicenseItem {
    licenseNum: number;
    licenseName: string;
    licenseLevel: number;
    licenseDevelopTime: number;
    productSalePrice: number;
    licenseImage: string;
    licenseMenualFile: string;
    licensePrice: number;
    licenseStatus: string;
    licenseRegDate: string;
    setLicenseStatus: Function;
    getLicenseList: Function;

    overlayAttr: any;
    handleHelpClick: any;
    now: any;
}

const LicenseItem: React.FC<iLicenseItem> = (props) => {
    const classes = useStyles();
    const { overlayAttr } = props;

    // const [licenseStatus, setLicenseStatus] = useState(props.licenseStatus);

    // const getLicenseConfirm = () => {
    //     const member = getMember();

    //     let url = new URL(basic.server + v_member.member + v_member.license_rnd_confirm);
    //     let params = {
    //         'companyNum': member.companyNum, 'classCode': member.classCode,
    //         'licenseNum': props.licenseNum, 'licensePrice': props.licensePrice,
    //         'licenseStatus': props.licenseStatus, email: member.id, 'name': member.name
    //     }
    //     // url.search = new URLSearchParams(params).toString();

    //     console.log(url)
    //     fetch(url.toString()).then((res) => {
    //         return res.json()
    //     }).then((data: any) => {
    //         console.log(data)
    //     })
    // }
    // const propsSetLicenseStatus = (status:string) => {
    //     console.log('status : ',status)
    //     props.setLicenseStatus(props.licenseNum, status)
    //     setLicenseStatus(status)
    //     // if (status == 'complete' || status =='can' || status =='cant')
    //     //     props.licenseStatus = status;
    //     // props.getLicenseList()
    // }

    // dateTime = dateTime.split(/[- :]/);
    // let date = new Date(dateTime[0], dateTime[1]-1, dateTime[2], dateTime[3], dateTime[4], dateTime[5]);

    // if (props.licenseRegDate != undefined) {
    //     console.log('level : ', props.licenseLevel)
    //     const now = Date.now()

    //     // let date = Date.now() - 5000;

    //     // start = (now - date)/1000;

    //     let date = new Date(props.licenseRegDate);

    //     start = (now - date.getTime())/1000
    //     console.log('now', now)
    //     console.log('regdate', date.getTime())
    //     console.log('regdate', date)
    //     console.log('start', start)
    //     if (start > props.licenseDevelopTime)
    //         start = props.licenseDevelopTime
    //     // start = 5
    //     console.log('start', start)
    // }

    /*
<Card className={classes.card}>
            {props.licenseStatus === 'cant' && overlayAttr !== undefined && overlayAttr.lastLicenseNum !== -1 && (overlayAttr.lastLicenseNum === props.licenseNum
                ? <OverlayLock firstCant={true} licenseName={overlayAttr.canLicenseName} />
                : <OverlayLock firstCant={false} licenseName={overlayAttr.canLicenseName} />)
            }
            <CardHeader
                className={classes.cardHeader}
                title={
                    <>
                        <Typography>{`Lv. ${props.licenseLevel} ${props.licenseName}`}</Typography>
                    </>
                }
            />
            <CardMedia

                className={classes.media}
                image={basic.server + '/displayImage?fileName=' + props.licenseImage}
            />
            <CardActions
                className={classes.cardAction}
            >
                {props.licenseStatus == 'complete'
                    ? <LicenseItemComplete
                        licenseName={props.licenseName}
                        licenseDevelopTime={props.licenseDevelopTime}
                        licenseRegDate={props.licenseRegDate}
                        getLicenseList={props.getLicenseList}
                        now={props.now}
                    />
                    : <LicenseItemCan
                        licensePrice={props.licensePrice}
                        licenseDevelopTime={props.licenseDevelopTime}
                        licenseNum={props.licenseNum}
                        productSalePrice={props.productSalePrice}
                        licenseImage={props.licenseImage}
                        licenseLevel={props.licenseLevel}
                        licenseName={props.licenseName}
                        licenseStatus={props.licenseStatus}
                        setLicenseStatus={props.setLicenseStatus}
                    />
                }
            </CardActions>
        </Card>
*/

    return (
        <Card className={classes.card} translate="no">
            {props.licenseStatus === 'cant' &&
                overlayAttr !== undefined &&
                overlayAttr.lastLicenseNum !== -1 &&
                (overlayAttr.lastLicenseNum === props.licenseNum ? (
                    <OverlayLock
                        firstCant={true}
                        licenseName={overlayAttr.canLicenseName}
                    />
                ) : (
                    <OverlayLock
                        firstCant={false}
                        licenseName={overlayAttr.canLicenseName}
                    />
                ))}
            <CardHeader
                className={classes.cardHeader}
                title={
                    <>
                        <Typography>{`Lv. ${props.licenseLevel} ${props.licenseName}`}</Typography>
                    </>
                }
            />
            <CardMedia
                className={classes.media}
                image={
                    basic.server +
                    '/displayImage?fileName=' +
                    props.licenseImage
                }
            />
            <CardActions className={classes.cardAction}>
                {props.licenseStatus == 'complete' ? (
                    <LicenseItemComplete
                        licenseName={props.licenseName}
                        licenseDevelopTime={props.licenseDevelopTime}
                        licenseRegDate={props.licenseRegDate}
                        getLicenseList={props.getLicenseList}
                        now={props.now}
                    />
                ) : (
                    <LicenseItemCan
                        licensePrice={props.licensePrice}
                        licenseDevelopTime={props.licenseDevelopTime}
                        licenseNum={props.licenseNum}
                        productSalePrice={props.productSalePrice}
                        licenseImage={props.licenseImage}
                        licenseLevel={props.licenseLevel}
                        licenseName={props.licenseName}
                        licenseStatus={props.licenseStatus}
                        setLicenseStatus={props.setLicenseStatus}
                    />
                )}
            </CardActions>
        </Card>
    );
};

interface iLicenseItemCan {
    licensePrice: number;
    licenseDevelopTime: number;
    licenseNum: number;
    productSalePrice: number;
    licenseImage: string;
    licenseLevel: number;
    licenseName: string;
    licenseStatus: string;
    setLicenseStatus: Function;
}

const LicenseItemCan: React.FC<iLicenseItemCan> = (props) => {
    const [dialogState, setDialogState] = useState(false);
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();

    const classes = useStyles();

    const handleClose = () => {
        setDialogState(false);
    };

    const handleOpen = () => {
        console.log('in handleOpen');
        if (!dialogState) {
            setDialogState(true);
        }
    };

    const action = (key: any) => (
        <Fragment>
            <Button
                onClick={() => {
                    closeSnackbar(key);
                }}
            >
                Close
            </Button>
        </Fragment>
    );

    const getLicenseRnd = (e: any) => {
        const member = getMember();

        let url = new URL(
            basic.server + v_member.member + v_member.license_rnd
        );
        // const requestOption = {
        //     method: 'POST',
        //     headers: {
        //         "Content-Type": "application/json; charset=utf-8"
        //     },
        //     body: JSON.stringify({
        //         'companyNum': member.companyNum, 'classCode': member.classCode,
        //         'licenseNum': props.licenseNum, 'licensePrice': props.licensePrice,
        //         'licenseLevel': props.licenseLevel, 'licenseImage': props.licenseImage,
        //         'productSalePrice': props.productSalePrice, 'licenseName': props.licenseName
        //     })
        // }
        // let params = { 'companyNum': member.companyNum.toString(), 'classCode' : member.classCode.toString(),
        //                 'licenseNum' : props.licenseNum.toString(), 'licensePrice' : props.licensePrice.toString(),
        //                 'licenseLevel' : props.licenseLevel.toString(), 'licenseImage' : props.licenseImage,
        //                 'productSalePrice': props.productSalePrice.toString()
        // }
        // url.search = new URLSearchParams(params).toString();

        // fetch(url.toString(), requestOption).then((res) => {
        //     return res.json()
        // })
        axios({
            method: 'POST',
            withCredentials: true,
            url: url.toString(),
            data: {
                companyNum: member.companyNum,
                classCode: member.classCode,
                licenseNum: props.licenseNum,
                licensePrice: props.licensePrice,
                licenseLevel: props.licenseLevel,
                licenseImage: props.licenseImage,
                productSalePrice: props.productSalePrice,
                licenseName: props.licenseName,
            },
        })
            .then((res) => res.data)
            .then((data: any) => {
                console.log(data);
                if (data.code == Values.SUCCESS_CODE) {
                    enqueueSnackbar('개발 요청을 성공했습니다.', {
                        variant: 'success',
                        autoHideDuration: SNACKBAR_TIME,
                        translate: 'no',
                    });
                    // props.setLicenseStatus(e, 'complete', data.regDate.development_date, data.now)
                    props.setLicenseStatus(
                        e,
                        'complete',
                        data.regDate,
                        data.now
                    );
                } else if (data.code == Values.FAIL_CODE) {
                    //if (data.msg) enqueueSnackbar(data.msg, { variant: "warning", autoHideDuration: SNACKBAR_TIME })
                    enqueueSnackbar('현금자산이 부족하여 구매가 불가합니다.', {
                        variant: 'warning',
                        autoHideDuration: SNACKBAR_TIME,
                        translate: 'no',
                    });
                } else {
                    if (data.msg)
                        enqueueSnackbar(data.msg, {
                            variant: 'error',
                            translate: 'no',
                        });
                    else
                        enqueueSnackbar('개발 요청에서 오류가 발생했습니다.', {
                            variant: 'error',
                            autoHideDuration: SNACKBAR_TIME,
                            translate: 'no',
                        });
                }
            });
        console.log('getLicenseRnd');
        // props.setLicenseStatus(e, 'complete')
        handleClose();
    };

    const getLicenseRndConfirm = () => {
        const member = getMember();

        let url = new URL(
            basic.server + v_member.member + v_member.license_rnd_confirm
        );
        let params = {
            companyNum: member.companyNum.toString(),
            classCode: member.classCode.toString(),
            licenseNum: props.licenseNum.toString(),
            licensePrice: props.licensePrice.toString(),
            licenseStatus: props.licenseStatus.toString(),
            email: member.id,
            name: member.name,
        };
        url.search = new URLSearchParams(params).toString();

        console.log(url);
        // fetch(url.toString()).then((res) => {
        //     return res.json()
        // })
        axios({
            method: 'GET',
            withCredentials: true,
            url: url.toString(),
        })
            .then((res) => res.data)
            .then((data: any) => {
                console.log(data);
                if (data.code == Values.SUCCESS_CODE) {
                    // enqueueSnackbar('success', {variant:'success'})
                    handleOpen();
                } else if (data.code == Values.FAIL_CODE) {
                    enqueueSnackbar(Values.FAIL_MESSAGE, {
                        variant: 'warning',
                        autoHideDuration: SNACKBAR_TIME,
                        translate: 'no',
                    });
                } else if (data.code == Values.CLASS_NO_START_CODE) {
                    enqueueSnackbar(Values.CLASS_NO_START_MESSAGE, {
                        variant: 'warning',
                        autoHideDuration: SNACKBAR_TIME,
                        translate: 'no',
                    });
                } else if (data.code == Values.CLASS_FINISH_CODE) {
                    enqueueSnackbar(Values.CLASS_FINISH_MESSAGE, {
                        variant: 'warning',
                        autoHideDuration: SNACKBAR_TIME,
                        translate: 'no',
                    });
                } else if (data.code == Values.EXCEPTION_CODE) {
                    enqueueSnackbar('에러가 발생하였습니다.', {
                        variant: 'error',
                        autoHideDuration: SNACKBAR_TIME,
                        translate: 'no',
                    });
                }
            });
    };

    return (
        <Grid container spacing={3} translate="no">
            <Grid item xs>
                <Grid container direction="column" style={{ gap: '5px' }}>
                    <Grid
                        container
                        alignItems="center"
                        className={classes.iconHeight}
                    >
                        <Grid item xs className={classes.iconItem}>
                            <img
                                className={classes.icon}
                                src="/images/price.webp"
                            />
                        </Grid>
                        <Grid>
                            <Typography variant="subtitle2">
                                <NumberFormat
                                    value={props.licensePrice}
                                    displayType={'text'}
                                    thousandSeparator={true}
                                    suffix={'원'}
                                />
                            </Typography>
                        </Grid>
                    </Grid>
                    <Grid
                        container
                        alignItems="center"
                        className={classes.iconHeight}
                    >
                        <Grid item xs className={classes.iconItem}>
                            <img
                                className={classes.icon}
                                src="/images/time.webp"
                            />
                        </Grid>
                        <Grid>
                            <Typography variant="subtitle2">
                                {props.licenseDevelopTime}초
                            </Typography>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
            <Grid
                item
                xs={8}
                style={{
                    display: 'flex',
                    justifyContent: 'flex-end',
                    alignItems: 'center',
                }}
            >
                <Button
                    variant="contained"
                    className={classes.button}
                    onClick={getLicenseRndConfirm}
                >
                    프로젝트 진행하기
                </Button>
                <DialogConfirm
                    open={dialogState}
                    handleClose={handleClose}
                    title={'프로젝트를 진행하시겠습니까?'}
                    context={`제품 : Lv.${props.licenseLevel} ${props.licenseName}`}
                    yesConfirm={getLicenseRnd}
                    noConfirm={handleClose}
                />
                {/* <Dialog open={dialogState} onClose={handleClose}>
                    <DialogTitle>프로젝트를 진행하시겠습니까?</DialogTitle>
                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                            Lv.{props.licenseLevel} {props.licenseName}을(를) 진행합니다.
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button variant="contained" color="primary" onClick={getLicenseRnd}>네</Button>
                        <Button variant="outlined" color="primary" onClick={handleClose} >아니오</Button>
                    </DialogActions>
                </Dialog> */}
            </Grid>
        </Grid>
    );
};

interface LicenseItemComplete {
    licenseName: string;
    licenseDevelopTime: number;
    licenseStatusStr: string;
    licenseRegDate: string;
}

const LicenseItemComplete: React.FC<any> = (props) => {
    const [progress, setProgress] = useState<number>(
        props.licenseRegDate == undefined || props.now == undefined
            ? props.licenseDevelopTime
            : Math.min(
                  props.licenseDevelopTime,
                  Math.max(
                      (new Date(props.now.replace(/-/g, '/')).getTime() -
                          new Date(
                              props.licenseRegDate.replace(/-/g, '/')
                          ).getTime()) /
                          1000,
                      0
                  )
              )
        // props.licenseDevelopTime
    );

    console.log(
        'now??',
        props.licenseName,
        props.now,
        props.now.replace(/-/g, '/'),
        new Date(props.now.replace(/-/g, '/')),
        new Date(props.now.replace(/-/g, '/')).getTime()
    );

    // console.log('license rnd??', props.licenseName, props.now, new Date(props.now),props.licenseRegDate, props.licenseDevelopTime)
    // console.log('\t', new Date(props.now).getTime() - new Date(props.licenseRegDate).getTime())
    // console.log('\t', Math.min(props.licenseDevelopTime, (
    //     Math.max((new Date(props.now).getTime() - new Date(props.licenseRegDate).getTime()) / 1000, 0)
    // )))
    // console.log('\t', new Date(props.now.replace(/-/g, "/")).getTime() - new Date(props.licenseRegDate.replace(/-/g, "/")).getTime())

    useEffect(() => {
        console.log('in useEffect!', props.licenseName, progress);
        // console.log('in useEffect!', props.licenseName, progress, (Date.now() - new Date(props.licenseRegDate.replace(/-/g, "/")).getTime()) / 1000)
        if (props.licenseRegDate != undefined) {
            console.log(
                'timer start!',
                props.licenseName,
                progress,
                (new Date(props.now.replace(/-/g, '/')).getTime() -
                    new Date(
                        props.licenseRegDate.replace(/-/g, '/')
                    ).getTime()) /
                    1000
            );
            const tick = setTimeout(() => {
                if (progress < props.licenseDevelopTime) {
                    setProgress(
                        (prevState) => Math.round((prevState + 0.1) * 10) / 10
                    );
                }
                if (progress == props.licenseDevelopTime) {
                    props.getLicenseList();
                    console.log('end!', props.licenseName);
                }
            }, 100);
            return () => clearTimeout(tick);
        }
    }, [progress, props.licenseRegDate]);

    return (
        <Grid container direction="column" translate="no">
            <Grid container justify="space-between" alignItems="center">
                <Grid xs={8}>
                    {progress == props.licenseDevelopTime ? (
                        <Typography
                            variant="h1"
                            style={{
                                color: `${COLORS.PUMPKIN}`,
                                fontWeight: 'bold',
                            }}
                        >
                            제품생산가능
                        </Typography>
                    ) : (
                        <>
                            <Typography
                                display="inline"
                                variant="h1"
                                style={{
                                    color: `${COLORS.BROWNISH_GREY}`,
                                    fontWeight: 'bold',
                                }}
                            >
                                {props.licenseName + ' 연구개발 '}
                            </Typography>
                            <Typography
                                display="inline"
                                variant="h1"
                                style={{
                                    color: `${COLORS.PUMPKIN}`,
                                    fontWeight: 'bold',
                                }}
                            >
                                {(
                                    (progress / props.licenseDevelopTime) *
                                    100
                                ).toLocaleString(undefined, {
                                    maximumFractionDigits: 0,
                                }) + '% '}
                            </Typography>
                            <Typography
                                display="inline"
                                variant="h1"
                                style={{
                                    color: `${COLORS.BROWNISH_GREY}`,
                                    fontWeight: 'bold',
                                }}
                            >
                                완료
                            </Typography>
                        </>
                    )}
                </Grid>
                <Grid xs={4} style={{ textAlign: 'end' }}>
                    {progress == props.licenseDevelopTime ? (
                        <Typography
                            variant="h1"
                            style={{
                                color: `${COLORS.BROWNISH_GREY}`,
                                fontFamily: 'NamumSquare_Regular',
                            }}
                        >
                            완료
                        </Typography>
                    ) : (
                        <Typography
                            variant="h1"
                            style={{
                                color: `${COLORS.BROWNISH_GREY}`,
                                fontFamily: 'NamumSquare_Regular',
                            }}
                        >
                            {Math.ceil(props.licenseDevelopTime - progress) +
                                '초 남음'}
                        </Typography>
                    )}
                </Grid>
            </Grid>

            <Grid>
                <Box alignItems="center">
                    <BorderLinearProgress
                        variant="determinate"
                        value={(progress / props.licenseDevelopTime) * 100}
                    />
                </Box>
            </Grid>
        </Grid>
    );
};

const BorderLinearProgress = withStyles({
    root: {
        height: 10,
        width: '100%',
        borderRadius: 20,
        // backgroundColor: lighten('#ff6c5c', 0.5),
    },
    bar: {
        borderRadius: 20,
        backgroundColor: `${COLORS.WATER_BLUE}`,
    },
})(LinearProgress);

const LicenseItemComplete3: React.FC<any> = (props) => {
    const [progress, setProgress] = useState(
        // props.licenseRegDate == undefined
        // ? props.licenseDevelopTime
        // : Math.min(props.licenseDevelopTime, (
        //     (Date.now() - new Date(props.licenseRegDate).getTime())/1000
        // ))
        props.licenseDevelopTime
    );

    useEffect(() => {
        console.log('in useEffect!', props.licenseName, progress);
        if (props.licenseRegDate != undefined) {
            let check = 0;
            console.log('timer start!');
            const tick = setTimeout(() => {
                let s =
                    (Date.now() -
                        new Date(
                            props.licenseRegDate.replace(/-/g, '/')
                        ).getTime()) /
                    1000;
                console.log('in timer ', s);
                if (s < props.end) {
                    setProgress(s);
                }
                if (progress == props.licenseDevelopTime && check == 0) {
                    console.log('check = ', check);
                    // props.getLicenseList();
                    check = 1;
                }
            });
        } else {
            setProgress(props.licenseDevelopTime);
        }
    }, [[props.licenseRegDate]]);

    return (
        <Grid container direction="column" translate="no">
            <Grid container justify="space-between" alignItems="center">
                <Grid xs={8}>
                    {props.licenseName +
                        ' 연구개발 ' +
                        (
                            (progress / props.licenseDevelopTime) *
                            100
                        ).toLocaleString(undefined, {
                            maximumFractionDigits: 0,
                        }) +
                        '% 완료'}
                </Grid>
                <Grid xs={4}>
                    {progress == props.licenseDevelopTime
                        ? '제품 생산 가능'
                        : Math.ceil(props.licenseDevelopTime - progress) +
                          '초 남음'}
                </Grid>
            </Grid>

            <Grid>
                <LinearProgressBar
                    progress={progress}
                    end={props.licenseDevelopTime}
                />
            </Grid>
        </Grid>
    );
};

const LicenseItemComplete2: React.FC<any> = (props) => {
    const [progress, setProgress] = useState(
        props.licenseRegDate == undefined
            ? props.licenseDevelopTime
            : Math.min(
                  props.licenseDevelopTime,
                  (Date.now() - new Date(props.licenseRegDate).getTime()) / 1000
              )
    );
    // let start = props.licenseDevelopTime;
    const [start, setStart] = useState(props.licenseDevelopTime);

    useEffect(() => {
        const tick = setTimeout(() => {
            if (progress < props.end) {
                let p = progress;
                setProgress(Math.min(p + 0.1, props.licenseDevelopTime));
            }
        });
    });

    // let start:number = props.licenseDevelopTime;
    // useEffect(()=> {
    //     console.log('regDate is change', props.licenseName)
    //     if (props.licenseRegDate != undefined) {
    //         setStart(Math.min(props.licenseDevelopTime, (
    //             (Date.now() - new Date(props.licenseRegDate).getTime())/1000
    //         )))
    //     }
    // }, [props.licenseRegDate])

    // useEffect(()=> {
    //     console.log('in Complete ', props.licenseRegDate)
    //     // console.log('in Complete ', start)
    //     if (props.licenseRegDate != undefined) {
    //         console.log('name : ', props.licenseName)
    //         const now = Date.now()

    //         let date = new Date(props.licenseRegDate);

    //         // start = (now - date.getTime())/1000
    //         let s = (now - date.getTime())/1000
    //         console.log('now', now)
    //         console.log('regdate', date.getTime())
    //         console.log('regdate', date)
    //         console.log('start', s)
    //         if (s > props.licenseDevelopTime) {
    //             // start = props.licenseDevelopTime
    //             console.log('s > devTime')
    //         } else {
    //             console.log('s < devTime')
    //             setStart(s)
    //         }
    //         console.log('start', start)
    //     }
    // }, [props.licenseRegDate])

    // if (props.licenseRegDate != undefined) {
    //     const now = Date.now()
    //     let date = new Date(props.licenseRegDate);

    //     let s = (now - date.getTime())/1000
    //     if (s > props.licenseDevelopTime) {
    //         start = props.licenseDevelopTime
    //     } else {
    //         start = s;
    //     }
    //     // console.log('in complete ',props.licenseName, start)
    // }

    const handleProgress = (iProgress: number) => {
        setProgress(iProgress);
    };

    const setDevelopComplete = () => {
        console.log('cb!!');
        props.getLicenseList();
    };

    return (
        // <Grid container spacing={3} direction="column">
        //     <Grid container>
        //         <Grid>
        //             {props.licenseName + ' 연구개발 ' + progress/props.licenseDevelopTime * 100 + '% 완료'}
        //         </Grid>
        //         <Grid>
        //             {progress == props.licenseDevelopTime ? "제품 생산 가능" : props.licenseDevelopTime - progress + "초 남음"}
        //         </Grid>
        //     </Grid>
        //     <Grid>
        //         <LinearDeterminate start={0} end={props.licenseDevelopTime} cb={handleProgress} />
        //     </Grid>
        // </Grid>
        <Grid container direction="column" translate="no">
            <Grid container justify="space-between" alignItems="center">
                <Grid xs={8}>
                    {props.licenseName +
                        ' 연구개발 ' +
                        (
                            (progress / props.licenseDevelopTime) *
                            100
                        ).toLocaleString(undefined, {
                            maximumFractionDigits: 0,
                        }) +
                        '% 완료'}
                </Grid>
                <Grid xs={4}>
                    {progress == props.licenseDevelopTime
                        ? '제품 생산 가능'
                        : Math.ceil(props.licenseDevelopTime - progress) +
                          '초 남음'}
                </Grid>
            </Grid>

            <Grid>
                {/* <LinearDeterminate progress={progress} end={props.licenseDevelopTime} setProgress={handleProgress} cb={setDevelopComplete}/> */}
            </Grid>
        </Grid>
    );
};

const LicenseItemCant: React.FC<any> = (props) => {
    return (
        // <Grid container spacing={3} direction="column">
        //     <Grid container>
        //         <Grid>
        //             {props.licenseName + ' 연구개발 100% 완료'}
        //         </Grid>
        //         <Grid>
        //             제품 생산 가능
        //         </Grid>
        //     </Grid>
        //     <Grid>
        //         <LinearWithValueLabel/>
        //     </Grid>
        // </Grid>
        <div></div>
    );
};

const OverlayLock: React.FC<any> = (props) => {
    const classes = useStyles();
    const { firstCant, licenseName } = props;

    return (
        <div
            className={
                firstCant
                    ? clsx(classes.overlay, classes.nextOverlay)
                    : classes.overlay
            }
            translate="no"
        >
            <img src="/images/lock.webp" className={classes.overlayImage}></img>
            <Typography
                variant="h1"
                style={{ fontWeight: 'bold', color: `${COLORS.WHITE}` }}
            >
                {`'${licenseName}' 프로젝트를 먼저 진행하세요.`}
            </Typography>
        </div>
    );
};

export default LicenseList;
